/* eslint-disable @typescript-eslint/no-explicit-any */
import { FetchArgs as BaseFetchArgs } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import { FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query/react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/src/query/baseQueryTypes';
import { buildPersistedQueryExtension } from './buildPersistedQueryExtension';
import { graphqlFetchBaseQuery, GraphqlFetchVariables } from './graphqlFetchBaseQuery';

interface BaseQueryWithPersistedFetchArgs extends Omit<BaseFetchArgs, 'body'> {
  body: { query: string; variables?: GraphqlFetchVariables };
}

interface GraphqlError {
  message: string;
  extensions?: { code?: string };
}

type BaseQueryWithPersisted = BaseQueryFn<
  BaseQueryWithPersistedFetchArgs,
  any,
  FetchBaseQueryError,
  unknown,
  FetchBaseQueryMeta
>;

export const baseQueryWithPersisted: BaseQueryWithPersisted = async (args, api, extraOptions) => {
  if (api.type === 'mutation') {
    return graphqlFetchBaseQuery(args, api, extraOptions);
  }

  const persistedQuery = await buildPersistedQueryExtension(args.body.query);

  const responseWithoutQuery = await graphqlFetchBaseQuery(
    { ...args, body: { extensions: { persistedQuery }, variables: args.body.variables } },
    api,
    extraOptions
  );

  if (
    responseWithoutQuery.data?.errors &&
    responseWithoutQuery.data.errors.some(
      (e: GraphqlError) => e.extensions?.code === 'PERSISTED_QUERY_NOT_FOUND'
    )
  ) {
    return graphqlFetchBaseQuery(
      {
        ...args,
        body: {
          extensions: { persistedQuery },
          query: args.body.query,
          variables: args.body.variables,
        },
      },
      api,
      extraOptions
    );
  }

  return responseWithoutQuery;
};
